import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { $http } from '../../plugins';

export default function ServicePoint({ data, setValue, name, fdtList: DataFdtList, disabled }) {
  const [servicePoint, setServicePoint] = useState([{ label: '', value: '' }]);
  const [fdtList, setFdtList] = useState(DataFdtList);

  useEffect(() => {
    if (data.areaId) {
      $http
        .get(
          `/MasterData/ServicePoint/GetAutoCompleteWithCode?areaid=${data.areaId}&submissionOpen=true`
        )
        .then((res) => {
          setServicePoint(
            res.data.map((d) => ({
              label: d.value,
              value: d.key
            }))
          );
        });
    }
  }, [data.areaId]);

  return (
    <motion.form
      initial={{ opacity: 0, y: 10 }}
      exit={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex flex-col p-2 items-center">
      <div dir="ltr" className="grid grid-cols-3 gap-4">
        {servicePoint
          .filter((item) =>
            disabled
              ? fdtList.length > 0 && fdtList.some((it) => it.value === item.value)
              : !disabled
          )
          .map((item, i) => (
            <div
              onClick={() => {
                if (disabled) {
                  return;
                }
                //  not duplicate data on setFdtList  and on click remove item from fdtList is selected
                if (fdtList.some((it) => it.value === item.value)) {
                  const list = [...fdtList.filter((it) => it.value !== item.value)];
                  setFdtList(list);
                  setValue(name, list);
                  return;
                } else {
                  const list = [...fdtList, item];
                  setFdtList(list);
                  setValue(name, list);
                }
              }}
              key={i}
              className={`${fdtList.some((it) => it.value == item.value) && 'bg-purple-500/50'}
               border border-collapse border-primary/40 rounded-md p-1
               ${disabled && 'cursor-not-allowed'} text-sm text-center`}>
              {item.label}
            </div>
          ))}
      </div>
    </motion.form>
  );
}
